import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AttributesSectionRefreshEvent } from 'src/app/models/events/attributes-section-refresh-event';

@Injectable({
    providedIn: 'root',
})
export class AttributesSectionEventsService {
    /**
     * Emis lorsque la section doit être rechargée.
     */
    public needRefresh = new Subject<AttributesSectionRefreshEvent>();
}
